<template>
    <ion-menu swipe-gesture="true"
              side="end"
              type="overlay"
              menu-id="mainMenu"
              content-id="menu-content"
              @ionWillOpen="show = true"
              @ionDidClose="show = false"
              :disabled="!isAuthenticated">
        <ion-header>
            <router-link :to="{ name: 'UserIndex' }">
                <div class="user" @click="closeMenu">
                    <div v-if="!authLoading" class="user-bubble"
                         :class="{'active' : (show_user_bubble && show)}">
                        <span>Proszę uzupełnij swoje dane</span>
                    </div>
                    <svg><use xlink:href="#icon-person"></use></svg>
                    <span class="user-name">{{ getProfile.firstname }} {{ getProfile.lastname }}</span>
                </div>
            </router-link>
        </ion-header>
        <ion-content>
            <div class="scroll-y custom-scrollbar">
                <ion-list>
                    <ion-item v-for="item in menu" :key="item.title" @click="closeMenu">
                        <router-link :to="{ name: item.route }">
                            <svg><use :xlink:href="'#'+item.icon"></use></svg>
                            <span>{{ item.title }}</span>
                        </router-link>
                    </ion-item>
                    <ion-item>
                        <span class="logout-link" @click="logout($event)">
                            <svg><use xlink:href="#icon-logout"></use></svg>
                            <span class="text-light">Wyloguj się</span>
                        </span>
                    </ion-item>
                </ion-list>
<!--                <h3>_________Dev</h3>-->
            </div>
        </ion-content>
    </ion-menu>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import config from './menu/config'

    export default {
        name: 'MainMenu',
        data: () => ({
            show: false
        }),
        created(){
            this.$root.$on('ionSplitPaneVisible',() => {
                this.show = true
            });
        },
        computed: {
            ...mapGetters(['getRole','getProfile', 'isAuthenticated', 'isProfileLoaded']),
            ...mapState({
                authLoading: state => state.auth.status === 'loading',
//                name: state => `${state.user.profile.title} ${state.user.profile.name}`,
                profile: state => state.user.profile
            }),

            // generate menu
            menu(){
                let role = this.getRole;
                return role ? config[role] : null
            },

            // handle user bubble
            show_user_bubble(){
              // bubble is only for users, not salesmans
              if(this.getRole !== "salesman"){
                // define user fields required for bubble
                let fields = [
                  this.profile.firstname,
                  this.profile.lastname,
                  this.profile.iban,
                  this.profile.place,
                  this.profile.city,
                  this.profile.zipCode
                ]
                // extend user fields if not an entrepreneur
                if(this.profile.entrepreneur === "0"){
                  let extendedFields = [
                    this.profile.birthday,
                    this.profile.pesel,
                    this.profile.taxOfficeName,
                    this.profile.taxOfficeAddress
                  ]
                  fields = fields.concat(extendedFields)
                }
                // check all fields
                return this.findEmptyFields(fields) ? false : true
              }
            },

            // calculated_link(){
            //     return this.show_user_bubble ? 'UserEdit' : 'UserIndex'
            // }
        },
        methods: {
            findEmptyFields(arr){
                // this is the fastest way
                // stop array loop whenever item is empty
                return arr.filter(item => (item === "" || item === null)).length === 0
            },
            logout(e) {
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Informacja',
                        message: 'Czy chcesz sie wylogować?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                                handler: blah => {
                                    /* *** */
                                    this.$gtag.event('user', 'logout cancel')
                                },
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    this.$parent.$refs.menuController.close('mainMenu');
                                    this.$store.dispatch('AUTH_LOGOUT');
                                    this.$router.push({ name: 'Login' });
                                    //
                                    this.$gtag.event('user', 'logout')
                                    //
                                    return this.$ionic.toastController
                                        .create({
                                            message: 'Wylogowano poprawnie.',
                                            duration: 2000,
                                            mode: 'md'
                                        })
                                        .then(a => a.present())
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
            closeMenu() {
                setTimeout(()=>{
                    this.$parent.$refs.menuController.close('mainMenu');
                }, 300)
            }
        },
    }
</script>

<style lang="scss" scoped>

    //fix for select active class for children route
    a.router-link-active {
        color: #E4030B !important;
    }

</style>
